"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(_ref) {
  var bubbleMinHeight = _ref.bubbleMinHeight,
      primaryFont = _ref.primaryFont,
      paddingRegular = _ref.paddingRegular;
  return {
    fontFamily: primaryFont,
    margin: 0,
    minHeight: bubbleMinHeight - paddingRegular * 2,
    padding: paddingRegular,
    '& > :first-child': {
      marginTop: 0
    },
    '& > :last-child': {
      marginBottom: 0
    },
    '&.markdown': {
      '& img': {
        maxWidth: '100%'
      },
      '& pre': {
        overflow: 'hidden'
      }
    }
  };
}